module.exports = __webpack_public_path__ + "static/media/2.9a378644.jpg";